var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo__AuthLockBlock demo__relative demo__pointer"},[_vm._t("default"),(!_vm.user)?_c('div',{staticClass:"this__lock",on:{"click":_vm.openAuthModal}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }